export const isMobileBlurFeatureEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_MOBILE_BLUR_FEATURE === 'true';
};

export const isInviteApplicantFeatureEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_INVITE_APPLICANT_FEATURE === 'true';
}

export const isJobCentricFeatureEnabled = (): boolean => {
    return import.meta.env.VITE_JOBCENTRIC_FEATURE_ENABLED === 'true';
}

export const isExpandedInterviewOverlayFeatureEnabled = (): boolean => {
    return import.meta.env.VITE_EXPANDED_INTERVIEW_OVERLAY_FEATURE_ENABLED === 'true';
}

export const isNewDateRangePickerEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_NEW_DATERANGEPICKER === 'true';
}

export const isNewOnboardingPageEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_NEW_ONBOARDING_PAGE === 'true';
}

// VI-834: gate the redesigned jobseeker recording pages (Interview + AudioInterview).
// When enabled, both pages render the new Figma layout chrome-less (no <Layout>
// UIContainer wrapper, like the v2 LandingPage). All recording/blur/timer logic
// is unchanged — only the view layer differs.
export const isNewInterviewPageEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_NEW_INTERVIEW_PAGE === 'true';
}

// VI-717: gate the jobseeker header/footer that JTScreener now renders itself
// (instead of the parent jobseeker-ui frame). When enabled, a JobTarget-blue header
// and white footer wrap all jobseeker pages via <JobseekerChrome>. Flag-gated so we
// can flip it on in the same release as JST-1093 (which removes the parent's chrome)
// and roll back instantly if a duplicate header/footer shows during the transition.
export const isJobseekerHeaderFooterEnabled = (): boolean => {
    return import.meta.env.VITE_ENABLE_JOBSEEKER_HEADER_FOOTER === 'true';
}

// VI-664: gate the platforms <job-bar> web component (@jobtarget/shared-components).
// When enabled, the recruiter Interviews tab renders the shared job bar instead of the
// app's custom job selector. All downstream interview/filter logic is unchanged.
export const isPlatformsJobBarEnabled = (): boolean => {
    return import.meta.env.VITE_PLATFORMS_JOBBAR_ENABLED === 'true';
}